import { fetchJiraConsumption } from '../../services/jiraConsumption';
import { fetchBrickTimesheets } from '../../services/timesheets';
import { fetchAllPaginated } from '../../utils/supabaseQuery';
import { aggregateTimesheets, jiraCacheFromRows, phaseByBrickId } from './consumptionAggregates';

/* Heures consommées : feuilles de temps par brique et cache de la synchro Jira. */
export default function jiraConsumptionHandlers(deps) {
  const { setJiraData, setHoursByBrick, setHoursByBrickAndDev, setDailyHoursByPhase, appState } =
    deps;

  async function loadHoursByBrick(clients) {
    // Phase de chaque brique : nécessaire pour borner chaque saisie par la fenêtre de sa propre
    // phase (voir aggregateTimesheets) — pas seulement collecter les ids.
    const phaseOf = phaseByBrickId(clients || appState.clients || []);
    const allIds = Object.keys(phaseOf);
    if (!allIds.length) return;
    const allRows = await fetchAllPaginated(fetchBrickTimesheets(allIds));
    const { map, byDev, daily } = aggregateTimesheets(allRows, phaseOf);
    setHoursByBrick(map);
    setHoursByBrickAndDev(byDev);
    setDailyHoursByPhase(daily);
  }

  // Recharge le cache Jira persisté en base (appelé à l'ouverture de la vue Projets)
  async function loadJiraData() {
    const data = await fetchAllPaginated(fetchJiraConsumption());
    if (!data) return;
    const cache = jiraCacheFromRows(data);
    setJiraData((d) => ({ ...d, ...cache }));
  }

  return { loadHoursByBrick, loadJiraData };
}
